import { theme } from '@approvalmax/theme';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Item = styled(Link)`
    border-radius: ${theme.radius.xsmall};
    color: ${theme.color.midnight100};
    background: ${theme.color.silver80};
    transition: ${theme.duration.medium}ms ease-in-out;
    padding: 16px;
    display: block;

    &:focus,
    &:hover {
        text-decoration: none;
        background: ${theme.color.silver100};
        color: ${theme.color.blue100};
    }
`;
